import { format, getYear, getMonth } from 'date-fns'
import { func, bool, instanceOf } from 'prop-types'

import s from './date-picker-header.module.scss'

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const DEFAULT_MIN_YEAR = 1900
const DEFAULT_YEARS_FORWARD = 10

const DatePickerHeader = ({
  monthDate,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  changeMonth,
  changeYear,
  showMonthDropdown,
  showYearDropdown,
  minDate,
  maxDate,
}) => {
  const showDropdowns = showMonthDropdown || showYearDropdown

  const startYear = minDate ? getYear(minDate) : DEFAULT_MIN_YEAR
  const endYear = maxDate ? getYear(maxDate) : getYear(new Date()) + DEFAULT_YEARS_FORWARD

  const years = []
  for (let year = endYear; year >= startYear; year--) {
    years.push(year)
  }

  const currentYear = getYear(monthDate)
  const minMonth = minDate && getYear(minDate) === currentYear ? getMonth(minDate) : 0
  const maxMonth = maxDate && getYear(maxDate) === currentYear ? getMonth(maxDate) : 11

  return (
    <div className={s['calendar-header']}>
      <button
        className={s['calendar-header-change-month-btn']}
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
        type="button"
      >
        <i className="bi bi-chevron-left" />
      </button>

      {showDropdowns ? (
        <div className={s['calendar-header-dropdowns']}>
          {showMonthDropdown && (
            <select
              className={s['calendar-header-select']}
              value={getMonth(monthDate)}
              onChange={event => changeMonth(Number(event.target.value))}
            >
              {MONTH_NAMES.map((month, index) => ({ month, index }))
                .filter(({ index }) => index >= minMonth && index <= maxMonth)
                .map(({ month, index }) => (
                  <option key={month} value={index}>
                    {month}
                  </option>
                ))}
            </select>
          )}

          {showYearDropdown && (
            <select
              className={s['calendar-header-select']}
              value={getYear(monthDate)}
              onChange={event => changeYear(Number(event.target.value))}
            >
              {years.map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          )}
        </div>
      ) : (
        <div className={s['calendar-header-date']}>{format(monthDate, 'MMMM yyyy')}</div>
      )}

      <button
        className={s['calendar-header-change-month-btn']}
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
        type="button"
      >
        <i className="bi bi-chevron-right" />
      </button>
    </div>
  )
}

DatePickerHeader.propTypes = {
  decreaseMonth: func,
  increaseMonth: func,
  prevMonthButtonDisabled: bool,
  nextMonthButtonDisabled: bool,
  changeMonth: func,
  changeYear: func,
  showMonthDropdown: bool,
  showYearDropdown: bool,
  minDate: instanceOf(Date),
  maxDate: instanceOf(Date),
}

export default DatePickerHeader
